/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_FileInputs */

const cs_import_file = /** @type {(inputs: Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soubor`)
};

const en_import_file = /** @type {(inputs: Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

/**
* | output |
* | --- |
* | "File" |
*
* @param {Import_FileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_file = /** @type {((inputs?: Import_FileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_FileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_file(inputs)
	return cs_import_file(inputs)
});